import { get,getfile,getAt,postAt,DELETEAt } from '@/utils/http'
var apI = '/api/v1'

//附件记录删除
export const deleteAttachment = (data) => DELETEAt(apI + '/Attachment/' + data)
//附件记录查询
export const getAttachmentList = (data) => getAt(apI + '/Attachment/list',data)
//附件记录保存
export const saveAttachment = (data) => postAt(apI + '/Attachment/save',data)
//服务器文件删除
export const deleteUploadFile = (data) => getfile('/api/file/delete', data)



// WEBPACK FOOTER //
// ./src/api/gate/attach/index.js